module.exports = __webpack_public_path__ + "img/枪王射击.79e75229.png";